import React from 'react';
import { useFarmDateTime } from '../../../../hooks/useFarmDateTime';
import { Icon, Chip } from '@material-ui/core';
import { TaskListStatus } from '../../../../models/common';
import { useTranslation } from 'react-i18next';
import {
  HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItem,
  HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItemTemplate
} from '../../../../api/HealthSystemApi';

interface IProps {
  plan: HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItem;
  item: HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItemTemplate;
  expectedEndTime?: string | null;
}

const TaskPlanLibraryItem: React.FC<IProps> = (props) => {
  const { plan, item } = props;

  const { formatDate, formatTime } = useFarmDateTime();
  const { t } = useTranslation();

  const renderSubHeader = (item: HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItemTemplate) => {
    const parts: string[] = [];
    if (item.duration != null && item.durationUnit) {
      parts.push(`${t('f-tasks-manager-duration')}: ${item.duration} ${item.durationUnit}`);
    }
    if (props.expectedEndTime) {
      parts.push(`${t('f-tasks-expected-end-time')}: ${props.expectedEndTime}`);
    }
    return parts.join(' | ');
  };

  const renderAction = (plan: HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItem) => {
    switch (plan.status) {
      case TaskListStatus.Done:
        return (
          <Chip
            variant="outlined"
            size="small"
            className="!border-0 !bg-emerald-50 !text-emerald-700"
            icon={<Icon>{'check'}</Icon>}
            label={plan.completedAt && formatDate(plan.completedAt) + ' ' + formatTime(plan.completedAt)}
          />
        );

      case TaskListStatus.InProgress:
        return (
          <Chip
            variant="outlined"
            size="small"
            className="!border-0 !bg-amber-50 !text-amber-800"
            icon={<Icon>{'hourglass_empty'}</Icon>}
            label={t('f-tasks-lists-items-progress')}
          />
        );

      case TaskListStatus.ToDo:
        return (
          <Chip
            size="small"
            className="!border-0 !bg-slate-100 !text-slate-600"
            icon={<Icon>{'alarm'}</Icon>}
            label={t('f-tasks-lists-items-todo')}
          />
        );
    }
  };

  return (
    <div className="my-2 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-slate-200 bg-white px-4 py-3">
      <div className="flex items-center gap-3">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-50 text-indigo-600">
          <Icon className="!text-lg/none">checklist</Icon>
        </span>
        <div>
          <div className="text-sm font-medium text-slate-800">{item.name}</div>
          <div className="mt-1 text-xs text-slate-500">{renderSubHeader(item)}</div>
        </div>
      </div>
      {renderAction(plan)}
    </div>
  );
};

export default TaskPlanLibraryItem;
